import $ from './el.JsModules.js';

elabs.AnouncementBar = class {
  'use strict';

  constructor(element) {
    this.view = $(element);
    const marqueeElement = this.view.find('.el-announcement-bar__marquee');
    let marqueeContent = this.view.find('.el-announcement-bar-template').html();

    let cachedTreeCount = localStorage.getItem('el-tree-count');
    if (!cachedTreeCount) {
      // this is just a hack, as the tree count may not instantly be available when a customer visits for
      // the first time. Really this view would await the tree count to be ready, or dynamically update
      // although this view, you can't play with the contents without some sort of reinitialisation. So
      // this is fine for now...
      cachedTreeCount = '39,144'; // we may want to update this in the future
    }

    marqueeContent = marqueeContent.replace(/##ecologi/g, cachedTreeCount);

    new SuperMarquee(marqueeElement[0], {
      content: marqueeContent,
      speed: '0.04', // 0.0125 - 0.2... larger is faster
      pauseonhover: true,
    });

    requestTimeout(() => {
      $('.header-group').addClass('el-announcement-bar__marquee--initialised');
    }, 100);
  }
};

// Initialise all Image Scollers
elabs.onJavascriptReady(function () {
  $('.el-announcement-bar').each(function (index, element) {
    new elabs.AnouncementBar(element);
  });
});
